import { EventChannel } from "../EventChannel/EventChannel";

export interface CurrentPageInfo {
  pageType: string | null;
}

type Callback = (cpi: CurrentPageInfo) => void;

const PAGE_TYPE_CHANNEL = new EventChannel<CurrentPageInfo>();
let currentPageType: string | null = null;

export const setCurrentPage = (pageType: string) => {
  currentPageType = pageType;
  PAGE_TYPE_CHANNEL.trigger({ pageType });
};

export const getCurrentPage = (): CurrentPageInfo => ({
  pageType: currentPageType,
});

export const subscribeToCurrentPage = (cb: Callback) =>
  PAGE_TYPE_CHANNEL.subscribe(cb);

export const unsubscribeFromCurrentPage = (cb: Callback) =>
  PAGE_TYPE_CHANNEL.unsubscribe(cb);

export const clearCurrentPage = () => {
  currentPageType = null;
  PAGE_TYPE_CHANNEL.trigger({ pageType: null });
};
